import api from "./api";

export interface CrmSalesByClient {
  clientName: string;
  usd: number;
  count: number;
}

export interface CrmSalesOverTime {
  date: string;
  usd: number;
}

export interface CrmSalesByUser {
  userId?: string;
  userName: string;
  usd: number;
  count: number;
}

export interface CrmTodayTask {
  id: string;
  title: string;
  userId?: string;
  userName: string;
  prospectName?: string;
  statusName?: string;
}

export interface CrmDashboardData {
  closedLeads: number;
  closedLeadsPrevious: number;
  totalSalesUsd: number;
  totalSalesUsdPrevious: number;
  salesByClient: CrmSalesByClient[];
  salesOverTime: CrmSalesOverTime[];
  salesByUser: CrmSalesByUser[];
  todayTasks: CrmTodayTask[];
}

export const getCrmDashboard = async (
  initialDate: string,
  finalDate: string
): Promise<CrmDashboardData | null> => {
  try {
    const response = await api.get("/api/crmDashboard", {
      params: { initialDate, finalDate },
    });
    return response.data;
  } catch (error) {
    console.error("crmDashboard error", error);
    return null;
  }
};
